import { render, staticRenderFns } from "./academic_schdual_refereesystem_group_promote.vue?vue&type=template&id=1f6f257f&scoped=true&"
import script from "./academic_schdual_refereesystem_group_promote.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_group_promote.vue?vue&type=script&lang=js&"
import style0 from "./academic_schdual_refereesystem_group_promote.vue?vue&type=style&index=0&id=1f6f257f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f257f",
  null
  
)

export default component.exports